import { STORE_USER_DETAILS, CLEAR_USER_DETAILS } from "../actions";

export default function setUserDetails(state = {}, action) {
  switch (action.type) {
    case STORE_USER_DETAILS:
      return action.payload;
    case CLEAR_USER_DETAILS:
      return {};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/userDetails.js